import {stopScreensActionTypes} from "./actionTypes";

export function setIsStopscreenDisplayed(isStopscreenDisplayed) {
    return {
        type: stopScreensActionTypes.SET_IS_STOPSCREEN_DISPLAYED,
        isStopscreenDisplayed
    }
}